export default "__VITE_ASSET__b2dd8b09__"